import Layout from "@/components/Layout";
import { useLang } from "@/context/LanguageContext";
import { galleryImages } from "@/data/content";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function AboutPage() {
  const { t, lang } = useLang();

  return (
    <Layout>
      <section className="container-sv pt-24 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-neon-purple" style={{ background: "var(--sv-purple)" }} />
              <span className="font-display uppercase tracking-[0.35em] text-[10px] text-white/60">
                About
              </span>
            </div>
            <h1 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tight leading-[0.92]" data-testid="about-page-title">
              <span className="text-white">From Seoul </span>
              <span className="neon-text-purple">to your city.</span>
            </h1>
            <p className="mt-6 text-white/70 font-body text-lg max-w-2xl leading-relaxed">
              {t.pages.about.intro}
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="relative rounded-3xl overflow-hidden h-[300px] md:h-[420px]">
              <img src={galleryImages[5]} alt="" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between text-white">
                <span className="font-display uppercase tracking-[0.3em] text-[10px] text-white/70">
                  Prague · 2025
                </span>
                <span className="font-display font-black text-3xl">#1</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container-sv py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="font-display font-bold uppercase text-2xl md:text-3xl tracking-tight text-white">
              {t.pages.about.what}
            </h2>
            <p className="mt-4 text-white/65 font-body leading-relaxed">
              {t.pages.about.whatBody}
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold uppercase text-2xl md:text-3xl tracking-tight text-white">
              {t.pages.about.team}
            </h2>
            <p className="mt-4 text-white/65 font-body leading-relaxed">
              {t.pages.about.teamBody}
            </p>
          </div>
        </div>
      </section>

      <section className="container-sv py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { v: "120+", l: lang === "en" ? "Sold-out nights" : "Vyprodaných nocí" },
            { v: "85k", l: lang === "en" ? "Guests" : "Hostů" },
            { v: "#1", l: lang === "en" ? "in CZ / SK" : "v CZ / SK" },
            { v: "3", l: lang === "en" ? "Capital cities" : "Hlavní města" },
          ].map((s, i) => (
            <div key={i} className="rounded-2xl bg-[var(--sv-surface)] border border-white/5 p-6 md:p-8 text-center">
              <div className="font-display font-black text-4xl md:text-6xl text-white tracking-tighter">{s.v}</div>
              <div className="mt-2 font-display uppercase tracking-[0.25em] text-[10px] text-white/55">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="container-sv pb-32">
        <div className="relative rounded-3xl overflow-hidden p-10 md:p-16 border border-white/5"
          style={{
            background:
              "radial-gradient(ellipse at top left, rgba(168,85,247,0.25), transparent 60%), radial-gradient(ellipse at bottom right, rgba(236,72,153,0.18), transparent 60%), #0c0c0e",
          }}
        >
          <div className="font-display font-black uppercase text-3xl md:text-5xl tracking-tight leading-tight text-white max-w-2xl">
            {lang === "en" ? "Ready to dance with us?" : "Připraven tančit s námi?"}
          </div>
          <p className="mt-3 text-white/65 font-body max-w-md">
            {lang === "en"
              ? "Your next night out starts here."
              : "Tvoje další noc venku začíná tady."}
          </p>
          <Link to="/events" className="mt-8 sv-btn sv-btn-primary inline-flex" data-testid="about-events-cta">
            {lang === "en" ? "See all events" : "Všechny akce"} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </Layout>
  );
}
